import * as React from "react";
import PropTypes from "prop-types";
import { Box } from "rebass";
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  PinterestShareButton,
  RedditShareButton
} from "react-share";

import {
  Facebook,
  Twitter,
  Linkedin,
  Reddit,
  Pinterest,
  Flipboard,
  Feedly
} from "../SocialIcons";
import Link from "../Link/BlogLink";

import colors from "../../utils/theme/colors";

const css = `
  cursor: pointer;
  border: 2px solid ${colors.secondary2};
  padding: 5px;
  border-radius: 10px;            
  :hover {
    color: ${colors.white};
    border: 2px solid ${colors.primary1};
    background: ${colors.primary1};
  }`;

const SocialSidebar = ({ socialLinks, url, title, ...props }) => (
  <Box
    as="ul"
    {...props}
    css={`
      position: -webkit-sticky;
      position: sticky;
      top: 40px;
    `}
  >
    <FacebookShareButton style={{ marginBottom: "20px" }} url={url}>
      <Facebook size={44} css={css} {...props} />
    </FacebookShareButton>
    <TwitterShareButton
      style={{ marginBottom: "20px" }}
      url={url}
      title={title}
    >
      <Twitter size={44} css={css} {...props} />
    </TwitterShareButton>
    <LinkedinShareButton style={{ marginBottom: "20px" }} url={url}>
      <Linkedin size={44} css={css} {...props} />
    </LinkedinShareButton>
    <RedditShareButton style={{ marginBottom: "20px" }} url={url}>
      <Reddit size={44} css={css} {...props} />
    </RedditShareButton>
    <PinterestShareButton
      url={url}
      style={{ marginBottom: "20px" }}
      media="https://dashbouquet.com/assets/img/blog/aspnet-angular-post.jpg"
    >
      <Pinterest size={44} css={css} {...props} />
    </PinterestShareButton>
    <Link
      href={socialLinks[5].url}
      mb={2}
      color={colors.secondary2}
      target="_blank"
    >
      <Feedly size={44} css={css} {...props} />
    </Link>
    <Link
      href={`https://share.flipboard.com/bookmarklet/popout?v=2&title=${title}&url=${url.slice(
        0,
        -1
      )}`}
      data-network="flipboard"
      data-logevent="SOCIAL-Flip"
      mb={2}
      color={colors.secondary2}
      target="_blank"
    >
      <Flipboard size={44} css={css} {...props} />
    </Link>
  </Box>
);

SocialSidebar.propTypes = {
  socialLinks: PropTypes.arrayOf(PropTypes.object).isRequired,
  url: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
};

export default SocialSidebar;
